import { Component } from '@angular/core';
import { BaseDirective } from 'src/app/directives/base.directive';


@Component({
  selector: 'app-email-templates',
  templateUrl: './email-templates.component.html',
  styleUrls: ['./email-templates.component.sass']
})
export class EmailTemplatesComponent extends BaseDirective {
  override title = 'MENU.EMAIL-TEMPLATE';
}
